import { render } from "./SpecialRequestUpdateView.vue?vue&type=template&id=dcb0077a&scoped=true"
import script from "./SpecialRequestUpdateView.vue?vue&type=script&lang=js"
export * from "./SpecialRequestUpdateView.vue?vue&type=script&lang=js"

import "./SpecialRequestUpdateView.vue?vue&type=style&index=0&id=dcb0077a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb0077a"]])

export default __exports__